export const INTERCOM_APP_ID = 'gm42d7mo';

export const INTERCOM_CONFIG = {
  hideDefaultLauncher: true,
  horizontalPadding: 64,
  alignment: 'left',
};
